import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import "./newsevent.css";





import con1 from '../../assets/con1.jpg';
import con2 from '../../assets/con2.jpg';
import con3 from '../../assets/con3.jpg'; 
import con4 from '../../assets/con4.jpg';
import con5 from '../../assets/con5.jpg';
import con6 from '../../assets/con6.jpg';
import con7 from '../../assets/con7.jpg';
import con8 from '../../assets/con8.jpg';
import con9 from '../../assets/con9.jpg';
import con10 from '../../assets/con10.jpg';
import con11 from '../../assets/con11.jpg';
import con12 from '../../assets/con12.jpg';
import con13 from '../../assets/con13.jpg';
import con14 from '../../assets/con14.jpg';
import con15 from '../../assets/con15.jpg';
import con16 from '../../assets/con16.jpg';
import con17 from '../../assets/con17.jpg';
import con18 from '../../assets/con18.jpg';
import con19 from '../../assets/con19.jpg';
import con20 from '../../assets/con20.jpg';
import con21 from '../../assets/con21.jpg';
import con22 from '../../assets/con22.jpg';
import con23 from '../../assets/con23.jpg'; 
import con24 from '../../assets/con24.jpg';
import con25 from '../../assets/con25.jpg';
import con26 from '../../assets/con26.jpg';
import con27 from '../../assets/con27.jpg';
import con28 from '../../assets/con28.jpg';
import con29 from '../../assets/con29.jpg';
import con30 from '../../assets/con30.jpg';
import con31 from '../../assets/con31.jpg';
import con32 from '../../assets/con32.jpg';
import con33 from '../../assets/con33.jpg';
import con34 from '../../assets/con34.jpg';
import con35 from '../../assets/con35.jpg';
import con36 from '../../assets/con36.jpg';
import con37 from '../../assets/con37.jpg';
import con38 from '../../assets/con38.jpg';
import con39 from '../../assets/con39.jpg';
import con40 from '../../assets/con40.jpg';
import con41 from '../../assets/con41.jpg';
import con42 from '../../assets/con42.jpg';





const sections = [

  {
    title: '1st International Optometric Conference in Sri Lanka',
    images: [con1, con2, con3, con4, con5, con6, con7, con8, con9, con10, con11, con12, con13, con14, con15, con16, con17, con18, con19, con20, con21, con22, con23, con24, con25, con26, con27, con28, con29, con30, con31, con32, con33, con34, con35, con36, con37, con38, con39, con40, con41, con42],
  },
]





const DiyatharippuEyecare2026 = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
        <h1 align="center">DIYATHARIPPU – EYE CARE 2026</h1>
        <p className="intro-annualmeeting">
        DIYATHARIPPU – EYE CARE 2026 proudly marks the 1st International 
        Optometry Conference in Sri Lanka, bringing together optometrists, vision scientists, 
        educators, researchers, and industry leaders from across the globe. Organized with the 
        vision of advancing eye care standards, this landmark event serves as a dynamic platform for 
        knowledge exchange, professional collaboration, and innovation in optometry and vision science. 
        The conference will feature expert-led scientific sessions, keynote lectures, panel discussions, 
        and interactive workshops focused on emerging trends, clinical excellence, research advancements, 
        and global eye health challenges. DIYATHARIPPU – EYE CARE 2026 aims to inspire, connect, and empower 
        eye care professionals while strengthening Sri Lanka’s presence in the international optometry community.
        </p>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};
export default DiyatharippuEyecare2026